import { onUpcomingClick } from './onCardClick';

export const slides = document.querySelector('.glide__slides');

slides.addEventListener('click', onUpcomingClick);

